'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const clsx = require('clsx');
const React = require('react');
const SecondaryNav_SecondaryNavContext = require('./SecondaryNavContext.cjs.js');
const SecondaryNav_SecondaryNavItemContext = require('./SecondaryNavItemContext.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const secondaryNavList = "_secondary-nav-list_zkl68_1";
const styles = {
	secondaryNavList: secondaryNavList
};

const SecondaryNavList = ({ children, className }) => {
  const navItemContext = SecondaryNav_SecondaryNavItemContext.useSecondaryNavItemContext();
  const { expandedSectionKeys } = SecondaryNav_SecondaryNavContext.useSecondaryNavContext();
  const isTopLevelList = !navItemContext;
  const isHidden = isTopLevelList ? void 0 : !expandedSectionKeys.includes(navItemContext.itemId);
  return React__default.default.createElement("ul", { className: clsx.clsx(styles.secondaryNavList, className), "data-zds": true, hidden: isHidden, id: navItemContext === null || navItemContext === void 0 ? void 0 : navItemContext.listId }, children);
};

exports.SecondaryNavList = SecondaryNavList;
//# sourceMappingURL=SecondaryNavList.cjs.js.map
